import React from 'react';
import './Score.css';
import Storage from '../Storage/Storage';


const Score = function (props) {
  const { score, children } = props;

  return (
    <div className="score">
      {children}
      {
        score ?
          new Array(Math.floor(score))
            .fill()
            .map((value, index) => {
              const key = index;
              return (<img key={key} src={Storage.get('pawprint')} alt="Bewertung" />);
            })
          : ''
      }
    </div>
  );
};

export default Score;




// WEBPACK FOOTER //
// ./src/pages/Helpers/Score/index.js